export default __webpack_public_path__ + "static/6-254d696b831b07a69a48d96644e9e65b.jpg";